import { Link } from "react-router-dom";

import { SlimmingWeightManagement } from "../../../assets/data/PageData"; // Adjust the path as necessary

import LineofEngagement from "../../../components/LineofEngagement";

import { ServicesCoverImage } from "../../../assets/data/Imagedata";

import { GlobalData } from "../../../assets/data/GlodalData";

import seoData from "../../../assets/data/seo.json";
import { Helmet } from "react-helmet-async";
import { FaArrowRight, FaPhone, FaQuestion, FaWhatsapp } from "react-icons/fa";

const { title, description, keywords, canonical, ogImage } =
  seoData.SlimmingWeightManagementSEO;

const webDevelopmentCompany = () => {
  return (
    <div className="WebDevelopment">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Cyber Space Digital" />
        <meta name="language" content="en" />
        <meta name="distribution" content="global" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        {/* Canonical Link */}
        <link rel="canonical" href={canonical} />
      </Helmet>

      <main>
        {/* Title Card */}
        <section
          className="py-10 sm:py-40"
          style={{
            backgroundImage: `url("${SlimmingWeightManagement.coverimage}")`,
            backgroundSize:
              SlimmingWeightManagement.coverImage.style.backgroundSize,
            backgroundPosition:
              SlimmingWeightManagement.coverImage.style.backgroundPosition,
          }}
        >
          <div className="flex flex-col items-center md:flex-row justify-center">
            <div className="md:w-1/2 md:pr-10"></div>
            <div className="md:w-1/2 px-5">
              <div className="text-right md:text-left">
                <h1 className="text-2xl pb-5 md:text-6xl fade-in-down text-center text-white font-tusker">
                  {SlimmingWeightManagement.title}
                </h1>
                <p className="text-white sm:text-sm text-xs text-center sm:ml-0">
                  {SlimmingWeightManagement.subtitle}
                </p>

                <div className="mt-8 flex flex-wrap justify-center gap-4">
                  <Link to="/contactus">
                    <span className="transform rounded-md flex bg-white px-5 py-3 font-medium text-black transition-colors hover:bg-black sm:text-[14px] text-[12px] hover:text-white">
                      <FaPhone className="mr-2 my-auto" /> Get in Touch
                    </span>
                  </Link>

                  <a href={GlobalData.company.companyWhatsapp}>
                    <span className="transform sm:text-[14px] text-[12px] flex rounded-md bg-white px-5 py-3 font-medium text-black transition-colors hover:bg-black hover:text-white">
                      <FaWhatsapp className="mr-2 my-auto" /> WhatsApp
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section - 2 */}
        <section>
          <section className="text-center mx-auto my-12 lg:px-20">
            <p className="text-sm font-medium text-white">
              {SlimmingWeightManagement.section2.tagline}
            </p>
            <h2 className="pb-2 font-extrabold text-transparent text-2xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-600 mt-3">
              {SlimmingWeightManagement.section2.heading}
            </h2>
            <p className="text-sm font-medium text-white">
              {SlimmingWeightManagement.section2.description}
            </p>

                <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link to="/frequently-asked-questions">
                <span className="transform rounded-md bg-primary hover:bg-orange-500 flex px-5 py-3 font-medium text-white transition-colors  hover:text-white">
                  <FaQuestion className="mr-2 my-auto" /> Frequently Asked
                  Questions
                </span>
              </Link>
            </div>
          </section>
          <section className="my-12 px-6">
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 text-center">
              {SlimmingWeightManagement.services.map((service, index) => {
                return (
                  <div
                    key={index}
                    className="flex flex-col items-center justify-center p-4 border rounded-lg bg-gray-50 hover:bg-gray-100 transition"
                  >
                    <img
                      src={service.icon}
                      className="w-8 h-8 ml-auto mx-auto justify-center" // Set width and height to 30px (8 * 4 = 32px, close to 30px)
                      alt="illustration"
                      loading="lazy"
                      width={30}
                      height={30}
                    />
                    <p className="font-medium sm:text-[14px] text-[12px]">
                      {service.title}
                    </p>
                    <p className="sm:text-[12px] text-[10px]">
                      {service.description}
                    </p>
                    <Link to={service.link}>
                      <button className="bg-primary flex sm:text-[14px] text-[10px] font-medium px-2 py-2 mt-2 rounded-md">
                        Know More{" "}
                        <FaArrowRight className="text-sm ml-2 my-auto" />
                      </button>
                    </Link>
                  </div>
                );
              })}
            </div>
          </section>
        </section>

        {/* Section - 3 */}
        <section
          style={{
            backgroundImage: `url(${ServicesCoverImage})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
        >
          <div className="cursor-default py-40 flex flex-col items-center justify-center bg-black/70">
            <div className="text-center ">
              <h2 className="leading-tight tracking-tighter font-extrabold text-transparent text-4xl md:text-5xl lg:text-8xl bg-clip-text bg-yellow-400">
                WE BUILD
              </h2>
            </div>
            <div className="text-center">
              <h2 className="font-extrabold text-transparent text-5xl md:text-5xl lg:text-8xl bg-clip-text bg-orange-600 leading-tight tracking-tighter">
                SIMPLE BUT COMPLEX
              </h2>
            </div>
            <div className="text-center">
              <h2 className="font-extrabold text-transparent text-4xl md:text-5xl lg:text-8xl bg-clip-text bg-yellow-400 leading-tight tracking-tighter">
                STABLE COMMUNITY
              </h2>
            </div>
          </div>
        </section>

        {/*section -5*/}
        <LineofEngagement />

        {/* "need more help" section */}
        <section className="text-center mx-auto py-8 bg-primary">
          <h2 className="cursor-default font-extrabold text-transparent text-2xl md:text-5xl lg:text-6xl bg-clip-text bg-white mt-3  tracking-tight ">
            Need Help ?
          </h2>
          <p className="cursor-default text-sm font-medium text-black  mb-2">
            Explore our comprehensive documentation for more information on our
            services.
          </p>

          <div className="flex items-center justify-center gap-4 flex-wrap">
            <a
              href={`tel:${GlobalData.company.companyPhone}`}
              className="px-20 py-2 flex bg-white border rounded-md text-black text-sm hover:bg-gray-100"
            >
              <FaPhone className="mr-2 my-auto" /> Contactus
            </a>
            <Link to="/frequently-asked-questions">
              <button
                target="_blank"
                rel="noopener noreferrer"
                className="px-20 py-2 flex bg-white border rounded-md text-black text-sm hover:bg-gray-100"
              >
                <FaQuestion className="mr-2 my-auto" /> FAQ
              </button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default webDevelopmentCompany;
